import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Card, Row, Col, Select, Tooltip, Drawer, Button, DatePicker } from "antd";
import { TableComp } from 'sz-react-utils';
import Request from "../../request";
import moment from "moment";

let { Option } = Select;
const { RangePicker } = DatePicker;
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';



class VendorReport extends React.Component {
    state = {
        vendorsArr: [],
        vendorId: null,
        time: {
            from: moment().startOf('month'),
            to: moment().endOf('month'),
        },
        loading: false,
        exportParams: {}
    }


    loadVendors = async () => {
        let params = {
            count: 10000,
            results: 10000
        }
        let { data } = await Request.getVendorsDetails(params);

        data = data.reduce((temp, vv) => {
            temp.push({ id: vv._id, vendorName: vv.vendorName });
            return temp;
        }, [])
        this.setState({ vendorsArr: data })
    }

    componentDidMount() {
        this.loadVendors();
    }

    apiRequest = async (params) => {
        return new Promise(async (resolve) => {
            params.vendorId = this.state.vendorId;
            params.time = this.state.time;
            this.setState({ loading: true, exportParams: params });
            let response = await Request.getVendorReport(params);
            this.setState({ loading: false });
            resolve(response)
        })
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState({
            time: {
                from: date[0],
                to: date[1],
            },
        }, () => {
            this.table.current.reload()
        });
    };

    onOk = (value) => {
        this.setState({ showResults: true }, () => {
            this.reload();
        });
    };

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

     exportExcel = async () => {
        let params = this.state.exportParams
        let x = await Request.exportVendorReport(params);
        if (!x.error) {
          window.open(x.url)
        }
      }


    render() {
        let { vendorsArr } = this.state;
        let columns = [
            {
                title: 'Sr No.',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'VID',
                key: 'id',
                width: 80,
                searchTextName: 'VID',
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: 'Student Name',
            },
            {
                title: 'Currency',
                key: 'currency',
                dataIndex: 'visaDesk.selectedCourse.currency',
                searchTextName: 'currency',
                width: 120,
            },
            {
                title: 'Amount Transferred (as per SWIFT)',
                key: 'visaDesk.selectedCourse.totalSwiftAmount',
            },
            {
                title: 'Date of Transfer',
                key: 'swiftTransferDate',
                dataIndex: 'visaDesk.selectedCourse.swiftTransferDate',
                searchTextName: `Date of Transfer ${dateFormat}`,
                render: (text, record) => (
                    <div>{moment(record.visaDesk.selectedCourse.swiftTransferDate, 'YYYY-MM-DD').format(dateFormat)}</div>
                )
            }
        ];

        return (
            <PageHeaderWrapper title={'Forex Vendor Details'}>
                <Card bordered={true}>
                    <Row>
                        <Col span={6}>
                            <h4>Select Vendor</h4>
                            <Select
                                placeholder="Select Vendor"
                                showSearch={true}
                                style={{ width: 200 }}
                                value={this.state.vendorId}
                                onChange={(e) => {
                                    this.setState({ vendorId: e }, () => {
                                        this.table.current.reload()
                                    })
                                }}
                            >
                                {
                                    vendorsArr.map((val) => (
                                        <Option key={val.id} value={val.id}>{val.vendorName}</Option>
                                    ))
                                }
                            </Select>
                        </Col>
                        <Col span={7}>
                            <h4>FILTER BY DATE</h4>
                            <RangePicker
                                key={this.state.showDate ? "78" : "326"}
                                defaultValue={[moment(this.state.time.from), moment(this.state.time.to)]}
                                format="YYYY-MM-DD"
                                placeholder={["Start Time", "End Time"]}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={4}>
                            <Button type={'default'}
                            style={{marginTop:20}}
                                onClick={() => {
                                    this.exportExcel()
                                }}>Export Excel</Button>
                        </Col>
                    </Row>
                </Card>
                {
                    this.state.vendorId ?
                        <Card bordered={true}>
                            <TableComp
                                ref={this.table}
                                columns={columns}
                                apiRequest={this.apiRequest}
                                loading={this.state.loading}
                                extraProps={{ scroll: { x: 900 } }}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 20,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </Card>
                        : null
                }
            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VendorReport)